<template>
  <div class="reviews-awards">
    <b-container>
      <b-row>
        <b-col>
          <div class="ra-sections">
            <div
              v-if="awards.length > 0"
              class="awards-section ra-section"
            >
              <div class="title">
                <h2>Awards</h2>
              </div>
              <awards-section :content="awards" />
            </div>

            <div class="reviews-section ra-section">
              <div class="title">
                <h2>Reviews</h2>
              </div>
              <template v-if="reviews.length > 0">
                <reviews-section :content="reviews" />
              </template>
              <template v-else>
                <p>0 reviews found for this product.</p>
              </template>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ReviewsComponent from './Reviews.vue'
import AwardsComponent from './Awards.vue'

export default {
  name: 'reviews-and-awards',
  components: {
    'reviews-section': ReviewsComponent,
    'awards-section': AwardsComponent
  },
  props: {
    awards: {
      type: Array,
      required: true
    },
    reviews: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.ra-section {
  &:not(:last-child) { margin-bottom: 3em; }
  .title { margin-bottom: 2em; }
}
</style>
